import { GetStaticProps } from 'next';
import { getGlobalProps } from '../../utils/addGlobalQuery';
import { ComponentProps } from 'react';
import { PAGE_MAX } from '@oberoninternal/travelbase-website/dist/components/designsystem/Pagination';
import SearchList from '@oberoninternal/travelbase-website/dist/components/SearchList';
import SearchWrapper from '../../components/layout/SearchWrapper';
import Search from '@oberoninternal/travelbase-website/dist/components/Search';

const Index = (props: ComponentProps<typeof SearchList>) => (
    <SearchWrapper mb={7}>
        <Search
            {...props}
            amountPerPage={PAGE_MAX}
            ResultsComponent={SearchList}
            contentWrapperVariant="searchList"
            buttonTypes={['filters', 'map', 'sort']}
        />
    </SearchWrapper>
);
export default Index;

export const getStaticProps: GetStaticProps = getGlobalProps;
